
import { Options, Vue } from 'vue-class-component';
import { fgcService, FGCDonation } from '@/services/fgc.service';
import { Subscription } from 'rxjs';

@Options({})
export default class FGCAdminView extends Vue {
  currentTotal = 250;
  newTotal = '';
  donations: FGCDonation[] = [];
  resetDialog = false;
  deleteDialog = false;
  deletingId: number | null = null;
  editDialog = false;
  editForm = { id: 0, donor_name: '', amount: '', message: '' };
  snackbar = false;
  snackbarText = '';
  snackbarColor = 'success';

  private eventSub: Subscription | null = null;
  private donationsSub: Subscription | null = null;

  async mounted() {
    this.eventSub = fgcService.getEvent().subscribe(event => {
      if (event) {
        this.currentTotal = parseFloat(event.current_total as any);
        this.newTotal = this.currentTotal.toFixed(2);
      }
    });

    this.donationsSub = fgcService.getDonations().subscribe(donations => {
      this.donations = donations;
    });

    await Promise.all([
      fgcService.fetchEvent(),
      fgcService.fetchDonations()
    ]);
  }

  unmounted() {
    this.eventSub?.unsubscribe();
    this.donationsSub?.unsubscribe();
  }

  async updateTotal() {
    try {
      const total = parseFloat(this.newTotal);
      if (isNaN(total) || total < 0) {
        this.showSnackbar('Invalid total amount', 'error');
        return;
      }

      await fgcService.updateTotal(total);
      this.showSnackbar('Total updated successfully', 'success');
    } catch (e) {
      console.error(e);
      this.showSnackbar('Failed to update total', 'error');
    }
  }

  confirmReset() {
    this.resetDialog = true;
  }

  async resetEvent() {
    try {
      await fgcService.resetEvent();
      this.resetDialog = false;
      this.showSnackbar('Event reset successfully', 'success');
    } catch (e) {
      console.error(e);
      this.showSnackbar('Failed to reset event', 'error');
    }
  }

  openEdit(donation: FGCDonation) {
    this.editForm = {
      id: donation.id,
      donor_name: donation.donor_name,
      amount: parseFloat(donation.amount as any).toFixed(2),
      message: donation.message || ''
    };
    this.editDialog = true;
  }

  async saveEdit() {
    try {
      await fgcService.updateDonation(this.editForm.id, {
        donor_name: this.editForm.donor_name.trim(),
        amount: parseFloat(this.editForm.amount),
        message: this.editForm.message.trim()
      });
      this.editDialog = false;
      this.showSnackbar('Donation updated successfully', 'success');
    } catch (e) {
      console.error(e);
      this.showSnackbar('Failed to update donation', 'error');
    }
  }

  confirmDelete(id: number) {
    this.deletingId = id;
    this.deleteDialog = true;
  }

  async deleteDonation() {
    if (!this.deletingId) return;

    try {
      await fgcService.deleteDonation(this.deletingId);
      this.deleteDialog = false;
      this.deletingId = null;
      this.showSnackbar('Donation deleted successfully', 'success');
    } catch (e) {
      console.error(e);
      this.showSnackbar('Failed to delete donation', 'error');
    }
  }

  showSnackbar(text: string, color: string) {
    this.snackbarText = text;
    this.snackbarColor = color;
    this.snackbar = true;
  }

  formatDate(timestamp: string): string {
    return new Date(timestamp).toLocaleString();
  }
}
